
// Archivo generado automáticamente
export const appVersionSemVer = '2.08.06';
export const appVersionRelease = '260806.01';
